import { ProfileImage } from './ImageDetail'
import { ConferencePromo, MinimumCreatorDetail } from './ConferencePromo'
import SocialAccount from './SocialAccount'
import ObjectTypeDetail from './ObjectTypeDetail'
import ContentVisibility from './ContentVisibility'
import ContactInformation from './ContactInformation'
import Seo from './Seo'

export const MinimumDashboardCreatorDetail = `
  ${MinimumCreatorDetail}
  fragment MinimumDashboardCreatorDetail on CreatorDetail {
    associatedUser
    ...MinimumCreatorDetail
  }
`

const CreatorDetail = `
  ${ProfileImage}
  ${SocialAccount}
  ${ObjectTypeDetail}
  ${ContactInformation}
  ${ContentVisibility}
  ${ConferencePromo}
  ${Seo}
  fragment CreatorDetail on CreatorDetail {
    alternateLocales
    associatedUser
    biography
    company
    contentLocale
    creatorType
    honors
    id
    name
    profileImage {
      ...ProfileImage
    }
    secondaryLocale
    seo {
      ...Seo
    }
    socialAccounts {
      ...SocialAccount
    }
    submissions {
      ...ConferencePromo
    }
    title
    contactInformation @include(if: $includeContactInfo) {
      ...ContactInformation
    }
    url
    visibility {
      ...ContentVisibility
    }
  }
`
export default CreatorDetail
